export default {
  loading: 'Loading...',
  date_time_same_today: "Today",
  date_time_same_today_at: "Today at",
  date_time_same_yesterday: "Yesterday",
  date_time_same_yesterday_at: "Yesterday at",
  date_time_same_at: "at",
  month_1: "January",
  month_2: "February",
  month_3: "March",
  month_4: "April",
  month_5: "May",
  month_6: "June",
  month_7: "July",
  month_8: "August",
  month_9: "September",
  month_10: "October",
  month_11: "November",
  month_12: "December",
  mon_1: "Jan",
  mon_2: "Feb",
  mon_3: "Mar",
  mon_4: "Apr",
  mon_5: "May",
  mon_6: "Jun",
  mon_7: "Jul",
  mon_8: "Aug",
  mon_9: "Sep",
  mon_10: "Oct",
  mon_11: "Nov",
  mon_12: "Dec",
  online: 'Online',
  offline: 'Offline',
  edit: 'Edit',
  success: 'Success',
  error: 'Error',
  save: 'Save',
  profile: 'Profile',
  chats: 'Chats',
  settings: 'Settings',
  log_out: 'Log Out',
}
